import { useMutation } from 'react-query';
import request from '../../../../helpers/request';

const mutationFn = (data) => {
  return request.post(
    'Acceptance/record_on_acceptance',
    data,
    'Не удалось записаться на приемку',
    'Error'
  );
};

export const useRegistrationForAcceptance = (options) =>
  useMutation(mutationFn, {
    ...options,
    onSuccess: (data, variables) => {
      if (data !== 'Error' && options?.onSuccess) {
        options.onSuccess(data, variables);
      }
    },
  });
